import React from "react";
import {Link} from "react-router-dom";
import {companyName, contactColumns} from "../data";

const scrollPageToTop = () => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
};

const ContactInfo = () => {
    return (
        <div className="contact-info">
            <div className="contact-company">{companyName}</div>
            <div className="contact-bar">
                <nav className="footer-links">
                    <Link to="/subscription/kisisel-verilerin-korunmasi" onClick={scrollPageToTop}>KVKK</Link>
                    <Link to="/subscription/on-bilgilendirme-ve-diger-politikalar" onClick={scrollPageToTop}>
                        Ön Bilgilendirme Formu, Satış Politikası,<br/>
                        Teslimat Koşulları, İptal ve İade Prosedürü
                    </Link>
                </nav>
                <div className="contact-info-inner">
                {contactColumns.map((column) => (
                    <div className="contact-column" key={column.title}>
                        <div className="contact-title">{column.title}</div>
                        {column.lines.map((line) => (
                            <div className={line.strong ? 'contact-name' : 'contact-line'} key={line.label}>
                                {line.href
                                    ? (line.href.startsWith('http')
                                        ? <a href={line.href} target="_blank" rel="noreferrer">{line.label}</a>
                                        : <a href={line.href}>{line.label}</a>)
                                    : line.label}
                            </div>
                        ))}
                    </div>
                ))}
                </div>
            </div>
        </div>
    );
};

export default ContactInfo;
